import {ChangeDetectionStrategy, Component, computed, input, resource} from '@angular/core';
import {marked} from "marked";
import {httpResource} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {isNative} from "../../utils";
import {CapacitorHttp} from "@capacitor/core";

@Component({
  selector: 'homey-wiki-page',
  templateUrl: './wiki-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WikiPageComponent {
  public readonly slug = input.required<string>();

  private readonly markdownResource = isNative
    ? resource({
        params: () => this.slug(),
        loader: async ({params: slug}) => {
          const response = await CapacitorHttp.get({url: `${environment.baseUrl}/assets/wiki/${slug}.md`});
          return response.data as string;
        }
      })
    : httpResource.text(() => `${environment.baseUrl}/assets/wiki/${this.slug()}.md`);

  public readonly markdown = computed(() => {
    const raw = this.markdownResource.value();
    return raw ? marked.parse(raw, {async: false}) : '';
  });
}
